import React from 'react'

import { BackToListLink } from '@components/common/BackToListLink'

/**
 * "Retour projets" — the way out of a project, back to the list.
 *
 * A thin binding of the shared {@link BackToListLink} so the three synthesis
 * call sites (header, loading, error) cannot drift on label or destination.
 * The `data-cy` is `action--back-to-projects` (plural): the Informations /
 * Documents / Suivi pages already own `action--back-to-project`, which points
 * at a project rather than at the list.
 */
export const BackToProjectsLink: React.FC = () => (
  <BackToListLink
    to="/projects"
    label="Retour projets"
    data-cy="action--back-to-projects"
  />
)
